<form [formGroup]="formGroup" (ngSubmit)="addRecipient()" class="{{ renderMode }}">
  <table
    id="add-{{ recipientType }}"
    class="table-full-width"
    [ngClass]="renderMode === 'web-app' ? 'table-striped-solid-background table-td-border-right' : 'table-striped-solid-td-background'"
    >
    <tr>
      <td class="heading">
        @if (recipientType === 'person') {
          <h2>Recipients details</h2>
        }
        @if (recipientType !== 'person') {
          <h2>{{ recipientHeadingLabel }}</h2>
        }
      </td>
    </tr>
    @if (recipientType === 'person') {
      <tr id="add-person-recipient">
        <td>
          <label>Recipient name</label>
          <input type="text" placeholder="e.g. Jane Doe" formControlName="name" #focus />
        </td>
        <td>
          <label>Recipient email</label>
          <input type="email" placeholder="e.g. Jane.Doe@KyloePartners.com" formControlName="email" />
        </td>
        @if (recipientRoles?.length) {
          <td>
            <div class="vertical-flex-stack">
              <label>Recipient role</label>
              <mat-select class="auto-width" formControlName="role" placeholder="Choose role">
                @for (role of recipientRoles; track role) {
                  <mat-option [value]="role">{{ role }}</mat-option>
                }
              </mat-select>
            </div>
          </td>
        }
        <td>
          <button theme="small" type="submit" [disabled]="!formGroup.valid">Add recipient <mat-icon fontIcon="add"></mat-icon></button>
        </td>
      </tr>
    }
    @if (recipientType !== 'person') {
      <tr>
        <td>
          <label>{{ recipientNameLabel }}</label>
          <br />
          <app-entity-picker
            [embedded]="true"
            [searchTypes]="searchTypes"
            (keydown.enter)="$event.preventDefault()"
            (selected)="onRecipientNameSelected($event)">
          </app-entity-picker>
        </td>
      </tr>
    }
  </table>
</form>
<!--<span style="background-color: lightgreen">{{formGroup.value | json}} | valid={{formGroup.valid}}, dirty={{formGroup.dirty}}</span>-->

<!--TODO: MAKE THE STUPID DIALOG ANIMATE HEIGHT/WIDTH-->
